module.exports = __webpack_public_path__ + "img/treatments-2.10cd1654.png";